import { createFileRoute } from "@tanstack/react-router";
import { optionParam } from "@/utils/searchParams";

// A sort rather than a filter, but the same rule applies: it is a choice the
// admin made about this page, so leaving and coming back keeps it (NAV-45).
// Both choices are listed; "order" is the default, so it is simply never
// written — a URL that names it anyway still reads correctly.
const CATEGORY_SORTS = ["order", "alphabetical"] as const;

export type CategorySort = (typeof CATEGORY_SORTS)[number];

export type AdminCategoriesSearch = {
  sort?: CategorySort;
};

export const Route = createFileRoute("/admin/categories")({
  validateSearch: (search: Record<string, unknown>): AdminCategoriesSearch => ({
    sort: optionParam(CATEGORY_SORTS, search.sort),
  }),
});
